import React from 'react';

interface Props {
  color?: string;
  width?: number;
}

const Link = ({ color = '#D4D8E4', width = 21 }: Props) => (
  <svg width={width} viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M9.08325 9.79199V9.79199C10.6454 8.2299 13.1829 8.22499 14.745 9.78709L16.5208 11.5628C17.89 12.932 17.89 15.152 16.5208 16.5212V16.5212C15.1516 17.8904 12.9316 17.8904 11.5624 16.5212L10.8934 15.8522"
      stroke={color}
      fill="none"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M11.9167 11.208V11.208C10.3546 12.7701 7.81701 12.775 6.25491 11.2129L4.47917 9.43718C3.10996 8.06797 3.10996 5.84805 4.47917 4.47884V4.47884C5.84838 3.10964 8.0683 3.10964 9.4375 4.47884L9.71297 4.7543"
      stroke={color}
      fill="none"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);

export default Link;
